import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import * as Styled from './styles';
import * as SX from './sx';
import type { ReportEnrichmentRecordProps as Props } from './types';

export const ReportEnrichmentRecord = memo(({ className, route }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('ReportEnrichmentRecord', className)}
      sx={SX.root}
      justifyContent="center"
      alignItems="center"
    >
      <Link to={route}>
        <Button variant="outlined" color="primary" sx={SX.button}>
          Report
        </Button>
      </Link>
    </Styled.Wrapper>
  );
});

ReportEnrichmentRecord.displayName = 'ReportEnrichmentRecord';
